<template>
  <section class="interact-collect-create-fast-container">
    <div class="templates-wrap">
      <div class="title-wrap">
        <div class="icon jee-bg-light">
          <jee-icon iconClass="caijimoban"/>
        </div>
        <div class="title">采集模板</div>
      </div>
      <div class="template-list">
        <template v-for="(item, index) in templates">
          <div :key="index" class="template-item" @click="handleClickTemplate(item)">
            <div class="img">
              <el-image :src="$getPath(item.url)" fit="fill">
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <span>{{item.modelName}}</span>
          </div>
        </template>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'FastTemplate',
  data () {
    return {
      templates: []
    }
  },
  methods: {
    fetchCollectTemplateList () {
      this.$request.fetchCollectTemplateList().then(res => {
        if (res.code === 200) {
          this.templates = res.data
        }
      })
    },
    handleClickTemplate (item) {
      this.$emit('click', item)
    }
  },
  mounted () {
    this.fetchCollectTemplateList()
  }
}
</script>
<style lang="scss" scoped>
.interact-collect-create-fast-container{
  .templates-wrap{
    .title-wrap{
      display: flex;
      align-items: center;
      .icon{
        width: 45px;
        height: 45px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        .jee-svg-icon{
          font-size: 23px;
          fill: #ffffff;
        }
      }
      .title{
        font-size: 20px;
        font-weight: bold;
        color: #333333;
        padding-left: 10px;
      }
    }
    .template-list{
      display: flex;
      flex-wrap: wrap;
      padding-top: 30px;
      .template-item{
        display: flex;
        align-items: center;
        width: 225px;
        height: 70px;
        padding: 5px 10px 5px 5px;
        background-color: #f9f9f9;
        border-radius: 4px;
        margin-right: 20px;
        margin-bottom: 30px;
        .img{
          border-radius: 4px;
          width: 60px;
          margin-right: 10px;
          .el-image{
            width: 100%;
            height: 100%;
          }
        }
        span{
          color: #666666;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
